export default __webpack_public_path__ + "static/media/fajar.e0c9fd52.png";